import BookTableBtn from './book-table';

export default BookTableBtn;
